
import { computed, defineComponent, toRefs } from "vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "ToolbarHeader",
  setup() {
    const { current, isPassing } = useToolbar();
    const { panel } = toRefs(current);
    const { all: allPassing } = toRefs(isPassing);
    const isCalc = computed(() => panel.value === "ToolbarCalculator");
    return { panel, allPassing, isCalc };
  }
});
